// Converts an element to a unique CSS selector string (tries id, classes, then parent path/nth-of-type)
export function toUniqueSelector(el: Element): string {
  const escape = (s: string) => globalThis.CSS?.escape(s);

  // Prefer id
  const id = (el as HTMLElement).id;
  if (id) return `#${escape(id)}`;

  // Try a stable data attribute
  const datasetKeys = Object.keys((el as HTMLElement).dataset || {});
  for (const key of datasetKeys) {
    const val = (el as HTMLElement).dataset[key];
    if (val) {
      const candidate = `[data-${key}="${escape(val)}"]`;
      if (document.querySelectorAll(candidate).length === 1) return candidate;
    }
  }

  // Build path up the tree, testing uniqueness
  const parts: string[] = [];
  let current: Element | null = el;
  while (current?.nodeType === 1) {
    const tag = current.tagName.toLowerCase();
    const cls = Array.from((current as HTMLElement).classList || [])
      .map((c) => `.${escape(c)}`)
      .join('');
    let part = `${tag}${cls}`;

    // If classes/tag alone are not unique at document level, add :nth-of-type
    const parent = current.parentElement;
    if (parent && Array.from(parent.children).filter((c) => c.tagName === current!.tagName).length > 1) {
      const index =
        Array.from(parent.children)
          .filter((c) => c.tagName === current!.tagName)
          .indexOf(current) + 1;
      part += `:nth-of-type(${index})`;
    }

    parts.unshift(part);
    const candidate = parts.join(' > ');
    try {
      if (document.querySelectorAll(candidate).length === 1) return candidate;
    } catch {
      // ignore invalid selector errors and continue walking up
    }

    current = current.parentElement;
  }

  // Fallback: full path (may not be unique but is best-effort)
  return parts.join(' > ');
}
